import { TextareaHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

/*
 * Textarea — DESIGN_SYSTEM.md §2.1
 * Mirrors Input styling. Default min-height 80px; resize-y by default.
 */
const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        aria-invalid={error ? true : undefined}
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-line bg-surface px-3 py-2.5',
          // 16px below sm: anything smaller makes iOS Safari zoom on focus.
          'text-base sm:text-sm text-ink placeholder:text-text-muted',
          'transition-colors resize-y',
          'focus:outline-none focus:border-brand-500',
          'disabled:bg-surface-2 disabled:text-text-muted disabled:cursor-not-allowed',
          'aria-[invalid=true]:border-danger',
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
